var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"water-drop-container"},_vm._l((_vm.waterDrops),function(drop,index){return _c('div',{key:`drop-${index}`,staticClass:"water-drop",style:({
            left: drop.left + '%',
            animationDelay: drop.delay + 's',
            animationDuration: drop.duration + 's',
        })})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }